import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
} from "reactstrap";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import { OfferListTableOfferComponent, OfferListTableStatus } from '../../../../Data/Application/Ecommerce/OfferList';
import OfferListFilterHeader from './OfferListFilterHeader';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import { OfferListTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import { SVG } from '../../../../AbstractElements';

const OfferListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [offerListTableDatas, setOfferListTableDatas] = useState<OfferListTableDataColumnType[]>([]);

const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [totalRows, setTotalRows] = useState(0);
const [loading, setLoading] = useState(false);

   const [editModalOpen, setEditModalOpen] = useState(false);
    const [editData, setEditData] = useState<any>(null);

    // useEffect(() => {
    //   const fetchOffers = async () => {
    //     try {
    //       const response = await api.get('/api/OfferPlan/GetOfferPlan'); 
    //       if (response.status === 200) {
    //         setOfferListTableDatas(response.data.map((item: {offerPlanId:any, offerName: any; offerType: any; offerValue: any; isOfferActive: any; originalPrice: any }) => ({
    //           offerPlanId: item.offerPlanId,
    //           offer_title: item.offerName,
    //           offer_type: item.offerType === 1 ? "Percentage" : "Amount",
    //           offer_discount: item.offerValue,
    //           offer_status: item.isOfferActive ? "Active" : "Inactive",
    //           originalPrice: item.originalPrice
    //         })));
    //       }
    //     } catch (error) {
    //       console.error("Failed to fetch offer list:", error);
    //     }
    //   };
  
    //   fetchOffers();
    // }, []);


    const fetchOffers = async (page: number, size: number) => {
      try {
        setLoading(true);
        const response = await api.get(
          `/api/OfferPlan/GetOfferPlanPagination?pageNumber=${page}&pageSize=${size}`
        );
            if (response.status === 200) {
            setOfferListTableDatas(response.data.items.map((item: {offerPlanId:any, offerName: any; offerType: any; offerValue: any; isOfferActive: any; originalPrice: any }) => ({
              offerPlanId: item.offerPlanId,
              offer_title: item.offerName,
              offer_type: item.offerType === 1 ? "Percentage" : "Amount",
              offer_discount: item.offerValue,
              offer_status: item.isOfferActive ? "Active" : "Inactive",
              originalPrice: item.originalPrice
            })));
          setTotalRows(response.data.totalCount); // ⬅️ IMPORTANT
        }
      } catch (error) {
        console.error("Failed to fetch ticket list:", error);
      } finally {
        setLoading(false);
      }
    };
    
    
      useEffect(() => {
      fetchOffers(currentPage, pageSize);
    }, [currentPage, pageSize]);

    const handleDelete = async (id: number) => {
      Swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this offer!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
          if (result.isConfirmed) {
              confirmDelete(id);
          }
      });
    };

    const confirmDelete = async (id: number) => {
      try {
        await api.delete(`/api/OfferPlan/DeleteOfferPlan)?offerPlanId=${id}`);
        Swal.fire('Deleted!', 'Offer has been deleted.', 'success');
    
        // Optional: refresh the list
        setOfferListTableDatas((prev) => prev.filter((item: { offerPlanId: any; }) => item.offerPlanId !== id));
      } catch (error) {
        Swal.fire('Error!', 'Failed to delete the offer.', 'error');
        console.error("Delete error:", error);
      }
    }

    // Edit

     const handleEdit = (row: any) => {
        setEditData(row);
        setEditModalOpen(true);
      };
    
      const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
      };
    
      const handleEditSave = async () => {
        // if (!editData || !editData.offerPlanId || !editData.offer_title || !editData.offerType || !editData.offer_discount || !editData.originalPrice) {
        //   Swal.fire("Error!", "Please fill all fields before saving.", "error");
        //   return;
        // }
        if (editData.offer_title.trim() === "") {
          Swal.fire("Error!", "Offer title cannot be empty.", "error");
          return;
        }
        if (isNaN(Number(editData.offer_discount)) || Number(editData.offer_discount) < 0) {
          Swal.fire("Error!", "Please enter a valid offer discount.", "error");
          return;
        }
        if (isNaN(Number(editData.originalPrice)) || Number(editData.originalPrice) <= 0) {
          Swal.fire("Error!", "Please enter a valid original price.", "error");
          return;
        }
        if (editData.offerType === 1 && Number(editData.offer_discount) > 100) {
          Swal.fire("Error!", "For Percentage type, offer discount must be less than or equal to 100.", "error");
          return;
        }
        try {
          await api.put(`/api/OfferPlan/UpdateOfferPlan`, {
            offerPlanId: editData.offerPlanId,
            offerName: editData.offer_title, 
            offerType: editData.offerType  === 1 ? 1 : 2,
            offerValue: editData.offer_discount, 
            isOfferActive: editData.offer_status === "Active",
            originalPrice: editData.originalPrice,
            finalPrice:0
          });
          // setOfferListTableDatas((prev) =>
          //   prev.map((item: any) =>
          //     item.offerPlanId === editData.offerPlanId ? editData : item
          //   )
          // );
          await fetchOffers(currentPage, pageSize);
          setEditModalOpen(false);
          Swal.fire("Updated!", "The offer has been updated.", "success");
        } catch (error) {
          Swal.fire("Error!", "Failed to update the offer.", "error");
        }
      };
    

    const offerListTableDataColumn: TableColumn<OfferListTableDataColumnType>[] = [
      {
        name: "Offer Title",
        cell: (row) => <OfferListTableOfferComponent title={row.offer_title}/>,
        sortable: true,
        grow: 2,
      },
      {
        name: "Offer Type",
        selector: (row) => `${row.offer_type}`,
        sortable: true,
      },
      {
        name: "Offer Discount",
        selector: (row) => `${row.offer_discount}`,
        sortable: true,
      },
      {
        name: "Offer Price",
        selector: (row) => `${row.originalPrice}`,
        sortable: true,
      },
      {
        name: "Offer Status",
        cell: (row) =>  <OfferListTableStatus title={row.offer_status} />,
      },
      // {
      //   name: "Action",
      //   cell: (row) => <OfferListTableAction offerPlanId={row.offerPlanId} onDelete={handleDelete} />,
      // },

      {
              name: "Action",
              cell: (row) => (
                <div className="d-flex align-items-center gap-2">
                  <span
                    onClick={() => handleEdit(row)}
                    title="Edit"
                    style={{ cursor: "pointer" }}
                  >
                    <SVG
                      iconId="edit-content"
                      style={{ fill: "blue", width: 18, height: 18 }}
                    />
                  </span>
                  <span
                    onClick={() => handleDelete(Number(row.offerPlanId))}
                    title="Delete"
                    style={{ cursor: "pointer" }}
                  >
                    <SVG
                      iconId="trash1"
                      style={{ fill: "red", width: 18, height: 18 }}
                    />
                  </span>
                </div>
              ),
            },
    ];

  const filteredItems = offerListTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);


const handlePageChange = (page: number) => {
  setCurrentPage(page);
};

const handlePerRowsChange = (newPerPage: number, page: number) => {
  setPageSize(newPerPage);
  setCurrentPage(page);
};


  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <OfferListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  {/* <DataTable data={filteredItems} columns={offerListTableDataColumn} striped highlightOnHover pagination selectableRows subHeader subHeaderComponent={subHeaderComponentMemo} /> */}

                   <DataTable
                    data={filteredItems}
                    //  data={offerListTableDatas}
                    columns={offerListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer // ⬅️ 
                    paginationTotalRows={totalRows} // ⬅️ 
                    onChangePage={handlePageChange} // ⬅️ 
                    onChangeRowsPerPage={handlePerRowsChange} // ⬅️ 
                    paginationDefaultPage={currentPage} // ⬅️
                    paginationPerPage={pageSize} // ⬅️ 
                    progressPending={loading} // ⬅️ 
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
        <Modal
              isOpen={editModalOpen}
              toggle={() => setEditModalOpen(!editModalOpen)}
            >
              <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
                Edit Offer
              </ModalHeader>
              <ModalBody>
                {editData && (
                  <>
                    <FormGroup>
                      <Label>Title</Label>
                      <Input
                        name="offer_title"
                        value={editData.offer_title}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Offer Type</Label>
                      <Input
                        type="select"
                        name="offerType"
                        value={editData.offer_type === "Percentage" ? "1" : "2"}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const value = e.target.value === "Percentage" ? "1" : "2";
                          handleEditChange({
                            ...e,
                            target: {
                              ...e.target,
                              name: "offer_type",
                              value,
                            },
                          });
                        }}
                      >
                        <option value="1">Percentage</option>
                        <option value="2">Amount</option>
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>offer discount</Label>
                      <Input
                        name="offer_discount"
                        value={editData.offer_discount}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Offer Price</Label>
                      <Input
                        name="originalPrice"
                        value={editData.originalPrice}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>offer status</Label>
                        <Input
                        type="select"
                        name="offer_status"
                        value={editData.offer_status}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setEditData({
                          ...editData,
                          offer_status: e.target.value,
                          });
                        }}
                        >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        </Input>
                    </FormGroup>
                   
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleEditSave}>
                  Save
                </Button>
              </ModalFooter>
            </Modal>
    </Container>
  )
}

export default OfferListContainer